import * as navigation from 'Navigation';

export default class ConnectionDetailsTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'connection-details',
    };
  }
}
